
import Request from './request';

export default class User extends Request {

    query() {
        return `{
            user( login: "${ this.user }") {
                name
                avatarUrl
                email
                websiteUrl
                url
                bio
                login
            }
        }`;
    }
}